import { useAppState } from '@/overmind';

type SelectedTenant = {
  isSelected: true;
  tenantName: string;
  organizationName: string;
};

type NotSelectedTenant = {
  isSelected: false;
  tenantName: undefined;
  organizationName: undefined;
};

export function useTenantState(): SelectedTenant | NotSelectedTenant {
  const currentTenantState = useAppState().tenants.currentTenant;

  if (currentTenantState.type === 'SELECTED_TENANT') {
    return {
      isSelected: true,
      tenantName: currentTenantState.context.name,
      organizationName: currentTenantState.context.organizationName
    };
  } else {
    return {
      isSelected: false,
      tenantName: undefined,
      organizationName: undefined
    };
  }
}
